export default "__VITE_ASSET__0fb3d110__"